(ns practitest.frontend.project-history
  (:require
    [practitest.frontend.common.i18n :as i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components2.grid :as grid2]
    [practitest.frontend.components2.grid.common :as grid2.common]
    [practitest.frontend.components2.grid.fields :as grid2.fields]
    [practitest.frontend.events :as events]
    [practitest.frontend.landing.last-actions :refer [build-entity-url]]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))


(def entity-key :project-history)

;; Same as :text, but wraps the value in .ph-activity-cell-inner for its scrollbar (history2.scss).
(grid2.common/register-field-type!
  :project-history-activity
  grid2.common/header-title
  grid2.fields/simple-text
  (fn [column-info row]
    [:div.ph-activity-cell-inner (grid2.fields/parsed-cell column-info row)]))

(defn- with-entity-link
  "Rows come back with entity_type/entity_id/entity_display_id/entity_title -
   turn those into the {:url :title} map the Entity column's :custom-field-url
   field type expects. The ID column reads entity_display_id directly."
  [project-id row]
  (let [{:keys [entity_type entity_id entity_display_id entity_title]} row
        title (if (seq entity_title) entity_title (str "#" entity_display_id))]
    (assoc row :entity {:url   (build-entity-url entity_type entity_id project-id)
                        :title title})))

(def main-controller
  {:identity (fn [match] match)
   :start    (fn [match]
               (mixpanel/track "Project History Form" {:Action "History Opened"})
               ;; Built directly rather than via broutes/get-url - this route is nested
               ;; under /projects/:project-id, not the /p/:project-id alias other entities use.
               (re-frame/dispatch [::events/fetch-history-by-uri entity-key
                                    (str "/projects/" (get-in match [:path-params :project-id]) "/histories/items")]))})

(defn index []
  (let [project-id @(re-frame/subscribe [::subs/current-project-id])
        data (mapv (partial with-entity-link project-id)
                   @(re-frame/subscribe [::grid.subs/history [entity-key]]))]
    [:div.instances-container.ph-instances-container
     [:div.ph-title-bar
      [:h2.ph-page-title
       (get-translation "navigation.project-menu.project-history" "Project History")]]
     [grid2/grid
      {:columns          @(re-frame/subscribe [::grid.subs/columns [entity-key entity-key]])
       :fields           @(re-frame/subscribe [::subs/fields])
       :data             data
       :class            "data-grid-history ph-data-grid"
       :full-data?       true
       :resizable?       true
       :show-edit-columns? false

       :per-page-load        (fn [] 20) 
       :default-sort-settings [:created_at :desc]

       :on-expand-click  (fn [] (re-frame/dispatch [::common-events/toggle-expanded entity-key entity-key]))
       :expanded?        @(re-frame/subscribe [::grid.subs/expanded? entity-key entity-key])

       ;; Dedicated tracking per the ticket, not the grid's generic "Grid filters" event
       :on-filter-changed (fn [] (mixpanel/track "Project History Form" {:Action "History Filtered"}))

       ;; Required for the users filter to work correctly
       :get-field-props  (fn [field]
                            (re-frame/subscribe [::subs/field-props entity-key
                                                  (if (= :user_id field) :author field)]))}]]))

;; Called from histories/index.html.erb
(defn ^:export init [options]
  (let [{:keys [translation]} (js->clj options :keywordize-keys true)]
    (i18n/append-translation! @(re-frame/subscribe [::subs/current-locale]) translation)))
